export enum BrandColor {
  BurntOrange = 'burnt-orange',
  DeepForest = 'deep-forest',
  Forrest = 'forrest',
  Grape = 'grape',
  Grey = 'grey',
  LegacyBlue = 'legacy-blue',
  Mandarin = 'mandarin',
  Mauve = 'mauve',
  Mustard = 'mustard',
  PrimaryBlue = 'primary-blue',
  Redish = 'redish',
  Verde = 'verde'
}
